import { render, staticRenderFns } from "./activitiesProgramEdition.vue?vue&type=template&id=4032680e"
import script from "./activitiesProgramEdition.vue?vue&type=script&lang=js"
export * from "./activitiesProgramEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports